import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import Moment from 'moment';

import PageTitle from '../../../components/commons/pages/PageTitle';
import Loader from '../../../components/commons/loader/loader';
import * as User from '../../../utils/userHelpers';
import * as Cart from '../../../utils/cartHelper';
import * as UserActions from '../../../actions/userActions';
import * as OrdersActions from '../../../actions/ordersActions';

import withSizes from 'react-sizes';
class StripeResponsePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserLoggedIn: false,
    };

    this.renderOrderSuccessMessage = this.renderOrderSuccessMessage.bind(this);
    this.goBack = this.goBack.bind(this);
    this.loadOrder = this.loadOrder.bind(this);
  }

  componentDidMount() {

    if (!User.isLoggedIn()) {
      return;
    } else {
      this.loadOrder();
      this.setState({ isUserLoggedIn: true });
    }
    Cart.clearCart();

  }
  componentWillUnmount() {
    window.removeEventListener('cart_changed', this.updateCart);
  }


  render() {
    const { isUserLoggedIn } = this.state;
    const { loading, isMobile } = this.props;


    return (
      <div className={`page checkout-page ${isMobile ? 'mobile' : ''}`}>
        <div className="container">
          <PageTitle title="Review & Place Order" isMobile />
          {isUserLoggedIn?this.renderOrderSuccessMessage():null}
          

        </div>
        <Loader visibility={loading} />
      </div>
    )
  }

  loadOrder() {

    
    const query = new URLSearchParams(this.props.location.search);
    const orderId = query.get('orderId');

    if (!orderId) {
      console.error("Order id is required");
      return;
    }

    this.props.dispatch(OrdersActions.getOrderDetails(orderId, response => {

      console.log('ORDER_GET_RESPONSE', response);

      if (response.status) {
        const order = response.data;
        const transactionId = response.data?response.data.transactionID.slice(-6).toUpperCase():undefined;
        console.log('transactionId', transactionId);
        if(__GTAG__CONVERSION__ && transactionId) {
          gtag('event', 'conversion', { 'send_to': 'AW-802355097/EW8pCPeFwIMBEJnvy_4C', 'transaction_id': transactionId });
        }
        const products = order.products.map(p => ({
          id: p._id,
          ...p
        }));
        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            purchase: {
              actionField: {
                id: transactionId,
                ...order
              },
              products
            }
          }
        });
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: "Failed to load order details, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        })
      }
    }));
  }

 goBack() {
    this.props.history.goBack();
  }

  renderOrderSuccessMessage() {
    const query = new URLSearchParams(this.props.location.search);
    const orderId = query.get('orderId')
    return (
      <div className="message-container">
        <div className="title">Your order has been placed successfully.</div>
        <div className="info-message">We'll Notify You Via Text Message and Email with more details and when the Order is On It's Way.</div>
        <div className="links">
          <Link to="/">Continue Shopping</Link>
          <Link to={`/orders/${orderId}`}>View Order</Link>
        </div>
      </div>
    )
  }
 

}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    loading: (state.getIn(['orders', 'loading'])),
    error: state.getIn(['products', 'error']),
    user: state.getIn(['users', 'user']),
  };
})(StripeResponsePage));



// WEBPACK FOOTER //
// ./src/containers/billing/checkout/StripeResponsePage.js